import React from 'react';

import styled from 'styled-components';

import { InnerContainer } from 'components/ContentContainer/ContentContainer';
import StackHeader from 'components/StackHeader';

import { DisclaimerHeaderInterface } from 'interfaces/content-stack/modular-blocks/DisclaimerTypes';

const HeaderContainer = styled.div`
  background-color: ${(props) => props.theme.colors.whiteSmoke};
  border-top: 0.001rem ${(props) => props.theme.colors.lightGray} solid;
  border-bottom: 0.001rem ${(props) => props.theme.colors.secondaryGray2} solid;
  padding: 3rem 0;
  margin-bottom: 6rem;

  @media screen and (max-width: ${(props) => props.theme.breakpoints.lg}) {
    padding: 2.5rem 0;
    margin-bottom: 5rem;
  }

  @media screen and (max-width: ${(props) => props.theme.breakpoints.md}) {
    padding: 1.5rem 0;
    margin-bottom: 3.5rem;
  }

  @media screen and (max-width: ${(props) => props.theme.breakpoints.xs}) {
    padding: 1.5rem 0;
    margin-bottom: 3.5rem;
  }
`;

interface DisclaimerHeaderTypes {
  header: DisclaimerHeaderInterface;
}

const DisclaimerHeader: React.FC<DisclaimerHeaderTypes> = ({ header }) => {
  if (!header) {
    return null;
  }

  const { headerType, headerColor, content } = header;

  return (
    <HeaderContainer>
      <InnerContainer $paddingOverride={'0'}>
        <StackHeader defaultHeaderType='H5' headerType={headerType} headerPrimaryColor={headerColor} uppercase={true}>
          {content}
        </StackHeader>
      </InnerContainer>
    </HeaderContainer>
  );
};

export default React.memo(DisclaimerHeader);
